<template>
  <div class="idea-of-the-day">
    <div class="header">
      <div>
        <i class="icon-idea"></i>
        <span clsss="card-title">Idea of the Day</span>
        <span class="date">Created on {{createdDate}}</span>
      </div>
      <div class="hide" @click="hideIdea">
        <!-- <i class="icon-close"></i> -->
        Hide
      </div>
    </div>
    <idea-item :idea="idea" :id="id"></idea-item>
  </div>
</template>

<script>

import IdeaItem from '../IdeaItem.vue'
import mixinAutoResize from "../../mixins/autoResize.js";
import bus from '../../bus'

export default {
  components: {
    IdeaItem
  },
  data() {
    return {
      editMode: false,
      initialCategories: [],
      updatedCategories: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    createdDate() {
      return new Date(this.idea.created_at).toLocaleDateString('en-uk', {year:"numeric", month:"short", day:"numeric"}) 
    }
  },
  props: {
    idea: {
      type: Object,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    hideIdea() {
      localStorage.setItem("hideIdeaForToday", (new Date()).toLocaleDateString());
      bus.$emit('hide-idea-of-the-day');
    }
  },
  mixins: [mixinAutoResize],
}
</script>

<style lang="scss" scoped>
@use '../../styles/theme.scss';

.idea-of-the-day {
  margin-bottom: 16px;
  color: theme.$primary-color;
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.header i {
  font-size: 20px;
  margin-right: 8px;
  font-weight: 700;
}

.header span {
  font-weight: 700;
  margin-right: 8px;
}

.header span.date {
  font-size: 12px;
  font-weight: 300;
}

.idea-of-the-day::v-deep div.title  {
  background-color: #efedff;
  border-radius: 4px;
  border: 0; 
  box-shadow: none  ;
}
.idea-of-the-day::v-deep .edit-mode div.title  {
  background-color: white;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 10%) ;
}

.idea-of-the-day::v-deep span.icon-three-dots {
  color: theme.$primary-color;
}

.hide {
  color: #565656;
  padding: 2px 8px;
  cursor: pointer;
}
</style>